import { isFeatureEnabled } from '../utils/features';
import type { MagneticWallItemSize } from './MagneticWallItem';
import { usePostLayoutSize } from './PostLayoutSizeContext';
import { usePostTOC } from './PostTOCContext';

function useMagneticWallItemSize(): MagneticWallItemSize {
  const { isTOCOpen } = usePostTOC();
  const postLayoutSize = usePostLayoutSize();

  if (isFeatureEnabled('new_post_layout')) {
    if (['narrow', 'small'].includes(postLayoutSize)) {
      return 'compact';
    }

    return 'full';
  }

  switch (postLayoutSize) {
    case 'wide':
      return isTOCOpen ? 'compact' : 'full';
    case 'xWide':
      return 'full';

    default:
      return 'compact';
  }
}

export default useMagneticWallItemSize;
